
import { Product } from "@/types/product";

export const hdbasetKits: Product[] = [
  {
    id: "dxe-cat-s1-4k",
    groupId: "hdbaset",
    name: "DXE-CAT-S1-4K\nKIT",
    description: "About\n   \nThe DXE‑CAT is part of the growing Digital Xtreme Series. This product is different than the typical CAT extender found on the market today, as it not only breaks the price barrier, but the feature and usability aspects as well. All connectors are on one side to make wiring cleaner and rack mounting easier. Having the ability to power the device with the choice of transmit or receive reduces the installation time and keeps things neat. An industry first is Aurora's exclusive Power-Over-Ethernet circuit, which allows both the transmitter and receiver to be powered without the need of any wall supplies.\n\nPackage contents:\n\n• 1x DXE-CAT-T1-4K\n• 1x DXE-CAT-R1-4K1\n• 1x 24V DC 15 Watt Wall Supply\n• 1x DXE-CAT-E1 Wall / Desk Mount Ears",
    features: [
      "Transmit HDMI up to 4k 30Hz 36bit 230ft over one CAT 5e/6/7 cable",
      "4K UHD Resolution",
      "All connectors on one side for easier installation",
      "Bi-directional RS-232 & IR",
      "Power both units from TX or RX side with wall power supply",
      "Status LED for all connections on front",
      "Various mounting options",
      "Comes in a variety of models for different features & cost savings"
    ],
    specifications: [
      "Max Distance: 230ft",
      "Max Resolution: 4K UHD 30Hz",
      "Color Depth: 36bit",
      "RS-232: Max 115kbps",
      "IR without LXC: 30k-60kHz",
      "IR Output with LXC: 30Hz-100kHz",
      "IR Input with LXC: 30k-60kHz",
      "Front LED Status: Power, Status, HDMI, HDBaseT, RS-232 TX/RX, IR In/Out",
      "Front Selections: Reset",
      "HDBaseT Connector: RJ-45 WE/SS 8P8C",
      "RS-232 Connector: 3.5mm TRS",
      "IR Connector: 3.5mm TRS (Auto Sensing Direction for Blaster or Receiver)",
      "HDMI Connector: Type A 19 pin",
      "Power Connector: Diameter 1.35mm ID, 3.5mm OD",
      "Mechanical",
      "Housing: Black Aluminum Enclosure",
      "Dimensions [L x W x H]: 120mm x 77mm x 27.94mm [4.72\" x 3.03\" x 1.1\"]",
      "Weight: 395g [14 oz] TX / 395g [14 oz] RX",
      "Mounting: Wall Mounting and Rack Mounting",
      "Power Supply: 24v 0.65A DC (Only 1 required on either TX or RX)",
      "Power Consumption: 5 Watts (TX) 7 Watts (Rx) [max]",
      "Operation Temperature: 0~40° C [32~104° F]",
      "Relative Humidity: 20~90% RH [No Condensation]"
    ],
    images: [
      "/lovable-uploads/dca02ab1-3f9e-4871-8cd2-3a71ea0af9be.png",
      "/lovable-uploads/59cdb06a-0024-49f3-8af7-9ddee3ee31db.png"
    ],
    image: "/lovable-uploads/dca02ab1-3f9e-4871-8cd2-3a71ea0af9be.png",
    slug: "dxe-cat-s1-4k"
  },
  {
    id: "dxe-cat-s2-4k",
    groupId: "hdbaset",
    name: "DXE-CAT-S2-4K\nKIT",
    description: "The DXE-CAT-S2-4K is a 4K HDMI extender kit with HDBaseT™ technology. It can extend HDMI, bi-directional IR and RS-232 up to 230ft (70M) for 4K, and 330ft (100M) for 1080p. The DXE-CAT-S2-4K uses a single solid copper category cable. The units also offer power over cable from TX to RX removing the need for dual power supplies.\n\nConsistent with other Aurora designs, the DXE-CAT Series keeps all connectors on one side for clean rack mounting and simpler installation with ease of use at a competitive price point. The units have front LEDs showing connection status for better troubleshooting.\n\nPackage Contents:\n• 1x DXE-CAT-TX\n• 1x DXE-CAT-RX\n• 1x 24V DC Wall Supply\n• 1x Rack Ears",
    features: [
      "Transmit HDMI up to 4K 30Hz 4:4:4 (230ft) over one CAT6 cable",
      "4K30 4:4:4/RGB & UHD Resolution",
      "All connectors on one side for easier installation",
      "Bi-directional RS-232 & IR",
      "Power both units from TX or RX side with the wall power supply",
      "PoE eliminates dual power supplies",
      "Status LEDs for all connections on front",
      "LAN port for network access",
      "Various mounting options"
    ],
    specifications: [
      "Video Distance (CAT5e/6/6a/7): 230ft (70m) 4K/330ft (100m) 1080p",
      "Video Bandwidth: 10.2Gbps",
      "Video Support: 4K 30Hz RGB/4:4:4 8-bit",
      "HDCP Compliance: Yes",
      "Audio Support: All HDMI Embedded Audio, Including Dolby/DTS",
      "IR without LXC: 30k-60kHz",
      "IR Output with LXC: 30Hz-100kHz",
      "IR Input with LXC: 30k-60kHz",
      "RS-232: Bi-Directional 115k Baud Rate",
      "LAN: 100BaseT",
      "Front LED Status: Power, Status, HDMI, HDBaseT, RS-232 TX/RX, IR In/Out",
      "Front Selections: Reset",
      "HDBaseT Connector: RJ-45 WE/SS 8P8C",
      "RS-232 Connector: 3.5mm TRS",
      "IR Connector: 3.5mm TRS (Auto Sensing Direction for Blaster or Receiver)",
      "HDMI Connector: Type A 19 pin",
      "Power Connector: 2.1/5.5mm DC Single",
      "Mechanical: Mounting Size 1RU ½ Rack Width",
      "Dimensions [L x W x H]: 120mm x 77mm x 27.94mm [4.72\" x 3.03\" x 1.1\"]",
      "Weight: 395g [14 oz] TX / 395g [14 oz] RX",
      "Power Consumption: 5 Watts (TX) / 7 Watts (RX) [max]",
      "Operation Temperature: 0~40°C [32~104°F]",
      "Storage Temperature: -20~60°C [-4~140°F]",
      "Relative Humidity: 20~90% RH [No Condensation]"
    ],
    images: [
      "/lovable-uploads/0ebc06ce-ee8b-4106-a574-a12ecbf0fbb4.png",
      "/lovable-uploads/bf934b83-0dd0-4e21-ab3d-ffbbb8b0814e.png",
      "/lovable-uploads/fa423fb3-b97e-43e1-ba7e-e54e478f91eb.png"
    ],
    image: "/lovable-uploads/0ebc06ce-ee8b-4106-a574-a12ecbf0fbb4.png",
    slug: "dxe-cat-s2-4k"
  }
];
